export const environment = {
  production: true,
  buildId: '3446279678122151',
  configFile: 'config.json',
};
